module.exports = __webpack_public_path__ + "img/circle.8494d324.png";